// Copyright © 2021 Move Closer
import { TeaserBoxInnerGrid1XL } from './1XL';
import { TeaserBoxInnerGrid2L } from './2L';
import { TeaserBoxInnerGrid6SBigThumbnailsList } from './6S-big-thumbnails-list';
import { TeaserBoxInnerGrid6STextList } from './6S-text-list';
import { TeaserBoxInnerGrid6SThumbnailsList } from './6S-thumbnails-list';
import { TeaserBoxInnerGrid6TTextList } from './6T-text-list';
import { TeaserBoxInnerGrid8S } from './8S';
import { TeaserBoxInnerGrid4S } from './4S';
import { TeaserBoxInnerGrid8T } from './8T';
import { TeaserBoxInnerGridL2SBigThumbnailsList } from './L-2S-big-thumbnails-list';
import { TeaserBoxInnerGridL2STextList } from './L-2S-text-list';
import { TeaserBoxInnerGridL2SThumbnailsList } from './L-2S-thumbnails-list';
import { TeaserBoxInnerGridL4S } from './L-4S';
import { TeaserBoxInnerGridL8S } from './L-8S';
import { TeaserBoxInnerGridL5STextList } from './L-5S-text-list';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const teaserBoxInnerGrids = [
    TeaserBoxInnerGrid1XL,
    TeaserBoxInnerGrid2L,
    TeaserBoxInnerGrid6SBigThumbnailsList,
    TeaserBoxInnerGrid6STextList,
    TeaserBoxInnerGrid6SThumbnailsList,
    TeaserBoxInnerGrid6TTextList,
    TeaserBoxInnerGrid8S,
    TeaserBoxInnerGrid4S,
    TeaserBoxInnerGrid8T,
    TeaserBoxInnerGridL2SBigThumbnailsList,
    TeaserBoxInnerGridL2STextList,
    TeaserBoxInnerGridL2SThumbnailsList,
    TeaserBoxInnerGridL4S,
    TeaserBoxInnerGridL8S,
    TeaserBoxInnerGridL5STextList
];
